// ./src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './hooks/useAuth';
// Layouts
import MainLayout from './components/layout/MainLayout';
import DashboardLayout from './components/layout/DashboardLayout'; // <-- Import new layout

// Auth
import ProtectedRoute from './components/auth/ProtectedRoute';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import EvaaSurveyPage from './pages/EvaaSurveyPage';
import EvaaSurveyPreviewPage from './pages/EvaaSurveyPreviewPage'
import EvaaSurveyEditorPage from './pages/EvaaSurveyEditorPage'
import AudiencePage from './pages/AudiencePage';
import MainAudiencePage from './pages/MainAudiencePage';
import ResponsesPage from './pages/ResponsesPage';
import MainResponsePage from './pages/MainResponsePage'
import EvaaXPage from './pages/EvaaXPage';


import AnalyticsPage from './pages/AnalyticsPage';
import MainAnalyticsPage from './pages/MainAnalyticsPage';

import MainQuotasPage from './pages/MainQuotasPage';
import QuotasPage from './pages/QuotasPage'
// error pages
import NotFoundPage from './errorPages/404page'
import ServerErrorPage from './errorPages/500page'

// You'll want to create these new placeholder pages so the routes work
const UpgradePage = () => <div>Upgrade Page Content</div>;

// A simple component to check if user is authenticated and redirect from login if so
function PublicRoute({ children }) {
	const { isAuthenticated, isLoading } = useAuth();
	if (isLoading) return <div>Loading...</div>;
	return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
}

function AppContent() {
	return (
		<Routes>
			{/* Public routes using MainLayout (only has Header) */}
			<Route element={<MainLayout />}>
				<Route path="/" element={<HomePage />} />
			</Route>

			{/* Auth routes without any layout */}
			<Route
				path="/login"
				element={<PublicRoute><LoginPage /></PublicRoute>}
			/>
			<Route
				path="/register"
				element={<PublicRoute><RegisterPage /></PublicRoute>}
			/>

			{/* Protected routes with the new DashboardLayout */}
			<Route
				path="/dashboard"
				element={
					<ProtectedRoute>
						<DashboardLayout />
					</ProtectedRoute>
				}
			>
				{/* Child routes that will render inside DashboardLayout's <Outlet> */}
				<Route index element={<DashboardPage />} /> {/* This is the /dashboard page */}
			
				<Route path="responses" element={<MainResponsePage />} /> {/* /dashboard/responses */}
				<Route path="responses/:surveyId" element={<ResponsesPage />} /> {/* /dashboard/responses */}
				
				<Route path="quotas" element={<MainQuotasPage />} /> {/* /dashboard/responses */}
				<Route path="quotas/:surveyId" element={<QuotasPage />} /> {/* /dashboard/responses */}
				
				<Route path="analytics" element={<MainAnalyticsPage />} /> {/* /dashboard/analytics */}
				<Route path="analytics/:surveyId" element={<AnalyticsPage />} /> {/* /dashboard/analytics */}
				

				<Route path="audience" element={<MainAudiencePage />} />
				<Route path="audience/:surveyId" element={<AudiencePage />} />

				<Route path='agri-data-hub' element={<EvaaXPage/>} />
				
				<Route path="upgrade" element={<UpgradePage />} /> {/* /dashboard/upgrade */}
			
			</Route>
			
			{/* Protected routes with header only */}
			<Route
				path="/private"
				element={
					<ProtectedRoute>
						<MainLayout />
					</ProtectedRoute>
				}
			>
				<Route path="evaa-editor/:surveyId" element={<EvaaSurveyEditorPage />} />
			</Route>

			<Route
					path="/private/evaa-survey/preview/:surveyId"
					element={
						<ProtectedRoute>
							<EvaaSurveyPreviewPage />
						</ProtectedRoute>
					}
				/>
			{/* Public routes for surveys completion etc */}
			<Route
				path="/public"
			>
				<Route path="evaa-survey/:surveyId/:participantId" element={<EvaaSurveyPage />}> </Route>
			</Route>
			
			{/* Error routes for surveys completion etc */}
			<Route
				path="/errors/evaa/oops"
			>
				<Route path="fivehundred" element={<ServerErrorPage />}> </Route>
			</Route>
				
			{/* Fallback for any other route */}
			<Route path="*" element={<NotFoundPage />} />
		</Routes>
	);
}

function App() {
	return (
		<Router>
			<AuthProvider>
				<AppContent />
			</AuthProvider>
		</Router>
	);
}

export default App;